import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import 'bootstrap/dist/css/bootstrap.min.css';  
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';  
import { Link } from "react-router-dom";
import logo from "../../assets/all-images/winson-stone-logo.jpeg";
import "../../styles/header.css";
import { listProductCategories } from "../../graphql/queries";

const listProductCategoryLinks = [{}];

function NewHeader() {  

  const [listProductCat, setlistProductCat] = useState(listProductCategoryLinks);
  // const [fix,setFix] = useState(false);

  // function setFixed() {
  //   if (window.scrollY >= 392) {
  //     setFix(true)
  //   } else {
  //     setFix(false)
  //   }
  // }
  // window.addEventListener("scroll",setFixed)

  useEffect( () => {
     // (async () => {
    fetchTodos()
     // })
 }, [])
  const fetchTodos = async ()=> {
     try {
       const listProductCatData = await API.graphql(graphqlOperation(listProductCategories));
console.log(listProductCatData, "listProductCatData")

       const _productCategoriesList = listProductCatData?.data?.listProductCategories?.items
       setlistProductCat(_productCategoriesList)
     } catch (err) { console.log(err, 'error fetching listMenu') }
   }
  return (  
    <>  
      <Navbar className="new_header fixed-top" collapseOnSelect expand="lg" bg="" variant="">  
        <Container>  
          {/* <Navbar.Brand href="#home">Navbar Brand</Navbar.Brand>   */}
          <div className="mobile_bar  d-flex">
              <div className=" mobileViewLogo">
                <h1>
                <Link to="/home" className="d-flex align-items-center gap-2">
                <img 
                  src="https://ik.imagekit.io/og9wa9z3b/winson-Images/winson-stone-logo.jpeg?updatedAt=1736852257591"
                  alt="logo" 
                />
                </Link>
                </h1>
              </div> 
             <Navbar.Toggle aria-controls="responsive-navbar-nav" />  
             
          </div>    
          <Navbar.Collapse id="responsive-navbar-nav"> 
          <div className="logo logo_normal">
                <h1>
                  <Link to="/home" className="d-flex align-items-center gap-2">
                    <img 
                    src="https://ik.imagekit.io/og9wa9z3b/winson-Images/winson-stone-logo.jpeg?updatedAt=1736852257591"
                    height="40px" width="350px" alt="logo" />
                  </Link>
                </h1>
              </div> 
            <Nav className="me-auto header_content" >  
              <Nav.Link href="/">HOME</Nav.Link>  
              
              <NavDropdown title="PRODUCTS" id="collasible-nav-dropdown"> 
              {listProductCat.map((categoryList, index) => ( 
                <NavDropdown.Item key={index} href={`/product-category/${categoryList.navigateTo}`}>
                {categoryList.title}
                  </NavDropdown.Item>  
                ))}
                {/* <NavDropdown.Divider />   */}
              </NavDropdown>  
              <Nav.Link href="/gallery">GALLERY</Nav.Link>  
              <Nav.Link href="/about">ABOUT US</Nav.Link>  
              <Nav.Link href="/contact">CONTACT US</Nav.Link>  
               
            </Nav>  
             
          </Navbar.Collapse>  
        </Container>  
      </Navbar>  
    </>  
  );  
}  
export default NewHeader;  